/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const CalendarIconSvg = forwardRef((props, svgRef) => (
	<svg
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path
			d="M15.692 2.4c.18-.966.609-1.2 1.108-1.2.503 0 .933.237 1.112 1.218 1.917.053 3.052.255 3.834 1.036C22.8 4.51 22.8 6.206 22.8 9.6v6c0 3.394 0 5.091-1.054 6.146C20.69 22.8 18.994 22.8 15.6 22.8H8.4c-3.394 0-5.091 0-6.146-1.054C1.2 20.69 1.2 18.994 1.2 15.6v-6c0-3.394 0-5.091 1.054-6.146.782-.781 1.917-.983 3.834-1.036.179-.981.61-1.218 1.112-1.218.5 0 .928.234 1.108 1.2h7.384zM6 4.822c.004 1.97.54 2.378 1.2 2.378.663 0 1.2-.412 1.2-2.4h7.2c0 1.988.537 2.4 1.2 2.4.66 0 1.196-.409 1.2-2.378.489.015.888.042 1.23.088.689.093.804.225.817.24l.002.001v.002c.016.013.148.128.24.817.08.587.102 1.343.109 2.43H3.602c.007-1.087.03-1.843.108-2.43.093-.689.225-.804.24-.817l.001-.002h.002c.013-.016.128-.148.817-.24.342-.047.741-.074 1.23-.09zM3.6 10.8v4.8c0 1.765.005 2.847.11 3.63.093.689.225.804.24.817l.001.002h.002c.013.016.128.148.817.24.783.106 1.865.111 3.63.111h7.2c1.765 0 2.847-.005 3.63-.11.689-.093.804-.225.817-.24l.002-.001v-.002c.016-.013.148-.128.24-.817.106-.783.111-1.865.111-3.63v-4.8H3.6z"
			fill="currentColor"
			fillRule="evenodd"
		/>
	</svg>
))
CalendarIconSvg.displayName = 'CalendarIconSvg'

const CalendarIcon = forwardRef((props, ref) => <Icon component={CalendarIconSvg} ref={ref} {...props} />)
CalendarIcon.displayName = 'CalendarIcon'

CalendarIcon.defaultProps = {
	...Icon.defaultProps,
}
CalendarIcon.propTypes = {
	...Icon.propTypes,
}

export default CalendarIcon
export { CalendarIconSvg }
